import { createSelector } from '@reduxjs/toolkit';

import { SinkState } from './sink.types';

import { ApplianceModel } from '~/core/models';
import { RootState } from '~/redux/store';

export const selectSelectedBrowsingOption = ({
  sink,
}: RootState): SinkState['selectedBrowsingOption'] =>
  sink.selectedBrowsingOption;

export const selectSelectedSinksRaw = ({
  sink,
}: RootState): SinkState['selectedSinks'] => sink.selectedSinks;

export const selectSelectedSinks = createSelector(
  [selectSelectedSinksRaw],
  (selectedSinks) =>
    selectedSinks.reduce(
      (acc, next) => {
        acc[next.id] = (acc[next.id] ?? 0) + 1;

        return acc;
      },
      {} as Record<ApplianceModel['productId'], number>
    )
);

export const selectSelectedSinkProductId = ({
  sink,
}: RootState): SinkState['selectedSinkProductId'] => sink.selectedSinkProductId;

export const selectInStoreSinksUrl = ({
  sink,
}: RootState): SinkState['inStoreSinksUrl'] => sink.inStoreSinksUrl;

export const selectNumberOfSelectedChipMinimizers = createSelector(
  [selectSelectedSinksRaw],
  (selectedSinks) =>
    selectedSinks.reduce(
      (acc, item) => acc + (item.hasChipMinimizer ? 1 : 0),
      0
    )
);
